import React from "react"
import {
  FormControllerProps,
  withFormController,
} from "../Molecules/FormController"
import Toggle, { ToggleProps } from "./Toggle"

export interface CustomSwitchProps
  extends Omit<ToggleProps, "onChange">,
    FormControllerProps {
  /**
   * The Path at which the component lives
   */
  path: string
}
const CustomSwitch = ({
  onChange,
  path,
  value,
  onAdd,
  onRemove,
  ...otherProps
}: CustomSwitchProps) => {
  const handleChange = () => {
    onChange && onChange(path, !value)
  }
  return (
    <Toggle
      checked={value ? true : false}
      onChange={handleChange}
      {...otherProps}
    ></Toggle>
  )
}
export default withFormController(CustomSwitch)
